<template>
    <div class="py-4 container-fluid">
        <div class="card">
            <div class="card-header pb-0">
                <p class="mb-0  px-3 py-2 bg-gradient-success radius-top text-white">تغییر رمز عبور</p>
            </div>
            <div class="card-body pt-0">
                <form @submit.prevent="submit()" class="was-validated">
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <label class="form-control-label" for="userName">نام کاربری</label>
                            <input class="form-control" type="text" id="username" name="username"
                                :value="this.$store.state.currentUserInfo.username" disabled />
                        </div>
                        <div class="col-md-6">
                            <label class="form-control-label required" for="UFCurrentPassword">رمز عبور فعلی</label>
                            <input class="form-control" type="password" id="UFCurrentPassword" name="UFCurentPassword"
                                v-model.trim="currentPassword" autocomplete="password" />
                        </div>
                        <div class="col-md-6">
                            <label class="form-control-label required" for="UFNewPassword">رمز عبور جدید</label>
                            <input class="form-control" type="password" id="UFNewPassword" name="UFNewPassword"
                                v-model.trim="newPassword" />
                        </div>
                        <div class="col-md-6">
                            <label class="form-control-label required" for="UFRePassword">تکرار رمز عبور جدید</label>
                            <input class="form-control" type="password" id="UFRePassword" name="UFRePassword"
                                v-model.trim="rePassword" />
                        </div>
                    </div>

                    <hr class="horizontal dark" />
                    <template v-if="v.$error">
                        <show-errors :model-value="v.$errors"></show-errors>
                        <hr class="horizontal dark" />
                    </template>
                    <button type="button" class="btn bg-gradient-success" @click="submit()">ثبت تغییرات</button>
                    <button type="button" class="btn bg-gray-400 me-3 float-start" @click="$router.back()">
                        بازگشت
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import UserService from '@/services/User/User-service.js';
import { maxLength, sameAs, helpers, required, minLength } from '@vuelidate/validators';

export default {
    name: "UserForm",
    data() {
        return {
            v: this.$useVuelidate(),
            currentPassword: '',
            newPassword: '',
            rePassword: '',
        };
    },
    methods: {
        submit() {

            this.v.$validate();
            if (this.v.$error) {
                return;
            }

            let vm = {
                currentPassword: this.currentPassword,
                NewPassword: this.newPassword,
            };

            UserService.updateCurrentUserPass(vm).then(response => {
                let result = response.data;

                if (!result.success) {
                    this.$toast.error(result.message);
                } else {
                    this.$toast.success(result.message);
                }
            }).catch(e => {
                console.log(e);
            });

            this.v.$reset();
        },
    },
    created() {
    },
    validations() {
        let valObj = {
            currentPassword: {
                required: helpers.withMessage('لطفا "رمز عبور فعلی" را وارد کنید', required),
            },
            newPassword: {
                required: helpers.withMessage('لطفا "رمز عبور جدید" را وارد کنید', required),
                maxLength: helpers.withMessage('حد اکثر طول مجاز برای "رمز عبور جدید"، 50 کاراکتر است', maxLength(50)),
                minLength: helpers.withMessage('"رمز عبور جدید" باید حداقل شامل 5 کاراکتر باشد', minLength(5)),
            },
            rePassword: {
                sameAsPassword: helpers.withMessage('"تکرار رمز عبور جدید" با "رمز عبور جدید" تفاوت دارد', sameAs(this.newPassword)),
            },
        };

        return valObj;
    }
};
</script>
